<template>
    <div class="date-picker-month-selector">
        <icon name="chevron-left" scale="0.8" class="arrow" @click.native="onMonthChange" :class="{ 'disabled': !active }" v-if="position == 'left'" />
        <div class="month-name">{{ getMonthNameAndYear }}</div>
        <icon name="chevron-right" scale="0.8" class="arrow" :class="{ 'disabled': !active }" @click.native="onMonthChange" v-if="position == 'right'" />
    </div>
</template>

<script>

    export default {

        props: {
            date: {
                type: Date,
                default: () => {
                    return new Date();
                }
            },
            position: {
                type: String,
                required: true
            },
            active: {
                type: Boolean,
                required: true
            },
            year: {
                type: Number,
                required: true
            },
            month: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            }
        },

        methods: {

            onMonthChange() {

                if (this.active)
                    this.$emit('change');
            }

        },

        computed: {

            getMonthNameAndYear() {
                var monthName = this.monthNames[this.month];
                return `${monthName} ${this.year}`;
            }

        }

    }

</script>

<style lang="scss" scoped>

    .date-picker-month-selector {
        display: flex;
        align-items: center;
        user-select: none;
        .month-name

    {
        color: #6F6F6F;
        font-weight: bold;
        margin: auto;
        font-size: 15px;
    }

    .arrow {
        cursor: pointer;
    }

        .arrow.disabled {
            color: #ddd;
            cursor:default;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Common/RangedDatePicker/DatePickerMonthSelector.vue